// CSV Import wizard — 3-step: upload, preview/map, import
import { api } from './api.js';

let _file = null;
let _rows = [];
let _headers = [];
let _connectionId = null;

export function setConnection(id) { _connectionId = id; }

export function init() {
  const zone = document.getElementById('upload-zone');
  const fileInput = document.getElementById('csv-file');

  zone.addEventListener('click', () => fileInput.click());

  zone.addEventListener('dragover', e => { e.preventDefault(); zone.classList.add('dragover'); });
  zone.addEventListener('dragleave', () => zone.classList.remove('dragover'));
  zone.addEventListener('drop', e => {
    e.preventDefault();
    zone.classList.remove('dragover');
    if (e.dataTransfer.files.length) {
      fileInput.files = e.dataTransfer.files;
      handleFile(e.dataTransfer.files[0]);
    }
  });

  fileInput.addEventListener('change', () => {
    if (fileInput.files.length) handleFile(fileInput.files[0]);
  });

  document.getElementById('import-back-1').addEventListener('click', () => goStep(1));
  document.getElementById('import-next-2').addEventListener('click', () => doImport());
  document.getElementById('import-reset').addEventListener('click', () => {
    _file = null; _rows = []; _headers = [];
    fileInput.value = '';
    goStep(1);
  });
}

function handleFile(file) {
  _file = file;
  const reader = new FileReader();
  reader.onload = () => {
    parseCSV(reader.result);
    goStep(2);
  };
  reader.readAsText(file);
}

function parseCSV(text) {
  const delim = document.getElementById('csv-delimiter').value;
  const hasHeader = document.getElementById('csv-header').checked;
  const lines = text.split(/\r?\n/).filter(l => l.trim());

  if (hasHeader && lines.length > 0) {
    _headers = lines[0].split(delim).map(h => h.trim().replace(/^"|"$/g, ''));
    _rows = lines.slice(1).map(l => splitRow(l, delim));
  } else {
    _rows = lines.map(l => splitRow(l, delim));
    _headers = _rows[0] ? _rows[0].map((_, i) => 'Column ' + (i + 1)) : [];
  }

  renderPreview();
}

function splitRow(line, delim) {
  // Simple CSV split (handles quoted fields)
  const result = [];
  let current = '';
  let inQuotes = false;
  for (let i = 0; i < line.length; i++) {
    const ch = line[i];
    if (ch === '"') { inQuotes = !inQuotes; continue; }
    if (ch === delim && !inQuotes) { result.push(current.trim()); current = ''; continue; }
    current += ch;
  }
  result.push(current.trim());
  return result;
}

function renderPreview() {
  document.getElementById('preview-rows').textContent = _rows.length + ' rows';
  document.getElementById('preview-cols').textContent = _headers.length + ' columns';

  const table = document.getElementById('preview-table');
  let h = '<thead><tr>' + _headers.map(c => '<th>' + esc(c) + '</th>').join('') + '</tr></thead>';
  h += '<tbody>';
  for (const row of _rows.slice(0, 20)) {
    h += '<tr>' + row.map(v => '<td>' + esc(v) + '</td>').join('') + '</tr>';
  }
  table.innerHTML = h + '</tbody>';

  const sel = document.getElementById('import-hub-col');
  sel.innerHTML = '<option value="">(auto-generate)</option>' +
    _headers.map((h, i) => '<option value="' + i + '">' + esc(h) + '</option>').join('');
}

async function doImport() {
  goStep(3);
  const tile = document.getElementById('import-tile').value.trim() || 'imported_data';
  const hubColIdx = document.getElementById('import-hub-col').value;
  const bar = document.getElementById('import-bar');
  const statusText = document.getElementById('import-status-text');
  const results = document.getElementById('import-results');

  let imported = 0, skipped = 0, failed = 0;

  for (let i = 0; i < _rows.length; i++) {
    const row = _rows[i];
    const record = {};
    for (let j = 0; j < _headers.length; j++) {
      record[_headers[j]] = row[j] ?? '';
    }

    const hub = hubColIdx !== '' ? row[parseInt(hubColIdx)] : 'row_' + (i + 1);
    const json = JSON.stringify(record);

    try {
      const res = await api.execute(_connectionId, `STORE '${json.replace(/'/g, "\\'")}' INTO ${tile} HUBNAME='${hub}'`);
      if (res.success) imported++; else skipped++;
    } catch {
      failed++;
    }

    const pct = ((i + 1) / _rows.length * 100).toFixed(0);
    bar.style.width = pct + '%';
    statusText.textContent = 'Importing... ' + (i + 1) + '/' + _rows.length;
  }

  statusText.textContent = 'Import complete';
  results.classList.remove('hidden');
  document.getElementById('stat-imported').textContent = imported;
  document.getElementById('stat-skipped').textContent = skipped;
  document.getElementById('stat-failed').textContent = failed;
}

function goStep(n) {
  document.querySelectorAll('.wizard-panel').forEach(p => p.classList.remove('active'));
  document.getElementById('import-step-' + n).classList.add('active');
  document.querySelectorAll('.wizard-steps .step').forEach(s => {
    const sn = parseInt(s.dataset.step);
    s.classList.toggle('active', sn === n);
    s.classList.toggle('done', sn < n);
  });
  document.getElementById('import-results').classList.add('hidden');
}

function esc(s) {
  return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}
